import axios from "axios";

export default {
    namespaced: true,
    state: {
        authenticated:false,
        user:{},
        users:[],
        base64File:'',
        transactionNo:''
           
    },
    getters:{
        authenticated(state){
            return state.authenticated
        },
        user(state){
            return state.user
        },
        users(state){
            return state.users
        },
        base64File(state){
            return state.base64File
        },
        transactionNo(state){
            return state.transactionNo
        }
    },  
    mutations:{
        SET_AUTHENTICATED (state, value) {
            state.authenticated = value
        },
        SET_USER (state, value) {
            state.user = value
        },
        SET_USERS (state, value) {
            state.users = value
        },
        SET_BASE64_FILE(state,value){
            state.base64File = value
        },
        SET_TRANSACTION_NO(state,value){
            state.transactionNo = value
        }
    },
    actions:{
        async getAllUsers(context,param){
            const response = await axios.get('/api/users',{
                headers:{
                  'Authorization':`Bearer ${param.token}`,
                  "Access-Control-Allow-Headers": "*",
                   "Access-Control-Allow-Method" : "*",
                   "Access-Control-Allow-Origin": "*",
                   "Access-Control-Allow-Credentials": "*",
                }
              });
    
                if(response.status == 200){
    
                    context.commit('SET_USERS',response.data.data)
                }
           },

        async getFile(context,param){
            const response = await axios.get('/api/getDataImage/'+param.galleryid+'/'+param.path,{
                headers:{
                  'Authorization':`Bearer ${param.token}`,
                  "Access-Control-Allow-Headers": "*",
                   "Access-Control-Allow-Method" : "*",
                   "Access-Control-Allow-Origin": "*",
                   "Access-Control-Allow-Credentials": "*",
                }
              });
    
                if(response.status == 200){
                    return response.data
                    // context.commit('SET_BASE64_FILE',response.data)
                }
        },

        async setTransactionNo(context,param){
            const response = await axios.get('/api/getTransactionNo/'+param.module+'/'+param.count,{
                headers:{
                  'Authorization':`Bearer ${param.token}`,
                  "Access-Control-Allow-Headers": "*",
                   "Access-Control-Allow-Method" : "*",
                   "Access-Control-Allow-Origin": "*",
                   "Access-Control-Allow-Credentials": "*",
                }
              });
    
                if(response.status == 200){
                    return response.data
                }
        }

        
    }
}